import { render } from "./MyMessages.vue?vue&type=template&id=6df18f19"
import script from "./MyMessages.vue?vue&type=script&lang=js"
export * from "./MyMessages.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__